export default __webpack_public_path__ + "static/media/score-cpt-boomerang.5ce504fc.png";